interface SectionHeadingProps {
  index: string;
  label: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ index, label, title, desc }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 border-b border-background-200 pb-4 md:flex-row md:items-end md:justify-between">
      <div>
        <div className="flex items-center gap-2">
          <span className="font-heading text-sm font-bold text-primary-600">{index}</span>
          <span className="h-3 w-px bg-background-300"></span>
          <span className="zone-label text-[11px] font-medium text-foreground-500">{label}</span>
        </div>
        <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h3>
      </div>
      {desc ? (
        <p className="max-w-md text-xs leading-relaxed text-foreground-600 md:text-right md:text-sm">{desc}</p>
      ) : null}
    </div>
  );
}